import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://016d35b0481408cca07880d3e3857a9a@o4509111369400320.ingest.de.sentry.io/4509286264012880",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  enabled: process.env.REACT_APP_NODE_ENV === "production",
  environment: process.env.REACT_APP_NODE_ENV,
  integrations: [],
});

export default Sentry;
